<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="msg-view">
                        <p>{{ text }}</p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal"></div>
                        <!-- <div class="u-btn cancel" @click="closeModal"></div> -->
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.msg-modal{
    position: relative;
    width: 715px;
    height: 470px;
    font-size: 24px;
    color: #8e492e;
    background-image: url(~@/assets/images/bg-extra.png);
}

.title{
    width: 267px;
    height: 60px;
    margin: 15px auto 10px;
    background-image: url(~@/assets/images/title-success.png);  
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 666px;
    height: 137px;
    margin: 20px auto;
    background-image: url(~@/assets/images/bg-msg.png);
    color: #8e492e;
}

.msg-view p{
    padding: 0 36px;
    line-height: 1.8;
}

.msg-view b{
    color: #fe5a1e;
}

.msg-view .icon{
    display: inline-block;
    width: 31px;
    height: 30px;
    margin: 0 5px;
    background-image: url(~@/assets/images/icon-m3b.png);
    vertical-align: sub;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.ok{
    width: 262px;
    height: 79px;
    margin: 48px auto 0;
    background-image: url(~@/assets/images/btn-ok.png);    
}


</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/SuccessModal/successModal.vue